import { PricingPlan } from '../types';

export const PRICING_PLANS: PricingPlan[] = [
  {
    name: '프리티어',
    price: '무료',
    description: '개발자를 위한 무료 플랜',
    features: [
      '월 1,000회 호출',
      '샘플 데이터만 접근',
      '커뮤니티 지원',
      '기본 문서 접근',
    ],
    cta: '무료 시작하기',
    popular: false,
  },
  {
    name: '스타터',
    price: '₩50,000',
    period: '/월',
    description: '소규모 프로젝트에 적합',
    features: [
      '월 10,000회 호출',
      '기본 데이터 접근',
      '이메일 지원',
      'API 콘솔 이용',
    ],
    cta: '시작하기',
    popular: false,
  },
  {
    name: '프로페셔널',
    price: '₩200,000',
    period: '/월',
    description: '성장하는 비즈니스를 위한',
    features: [
      '월 100,000회 호출',
      '전체 데이터 접근',
      '실시간 알림',
      '전화 지원',
      '우선 기술 지원',
    ],
    cta: '시작하기',
    popular: true,
  },
  {
    name: '엔터프라이즈',
    price: '문의',
    description: '대규모 기업을 위한',
    features: [
      '무제한 호출',
      '커스텀 데이터',
      '전담 매니저',
      'SLA 보장',
      '온사이트 지원',
    ],
    cta: '문의하기',
    popular: false,
  },
];
